var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "phone_ic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone_ic",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.21044832,4.8844748 L8.78223891,9.45452287 C7.80048045,10.9834117 9.21229831,12.7974715 10.2086801,13.7932434 C11.2050619,14.7890153 13.0170278,16.2015757 14.5471618,15.2197632 L19.1142995,19.7891465 C17.5801773,21.0607831 15.6066899,21.3379773 13.3719763,20.5868276 C11.111895,19.7151958 9.074416,18.3508976 7.40764412,16.5931041 C5.64955665,14.9261745 4.28508674,12.8883268 3.41347581,10.6277789 C2.66170274,8.39227752 2.93954637,6.41934622 4.21044832,4.8844748 Z M17.1644089,13.393785 C17.620538,13.393785 18.0579792,13.5750191 18.3804733,13.8976067 L20.496206,16.0127911 C20.8187758,16.335303 21,16.7727683 21,17.2289225 C21,17.6850766 20.8187758,18.122542 20.496206,18.4450538 L19.9139308,19.0266963 L15.3667341,14.4792492 L15.9483445,13.8976067 C16.2708386,13.5750191 16.7082799,13.393785 17.1644089,13.393785 Z M6.7711961,3 C7.22732514,3 7.66476643,3.18123417 7.98726049,3.50382174 L10.1029932,5.61900617 C10.7736189,6.29106594 10.7736189,7.37920906 10.1029932,8.05126884 L9.52138272,8.63291132 L4.97352125,4.08546422 L5.55513171,3.50382174 C5.87762578,3.18123417 6.31506706,3 6.7711961,3 Z",
    id: "Combined-Shape",
    fill: "#081420",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhone);
export default __webpack_public_path__ + "static/media/ic_phone.386f6fea.svg";
export { ForwardRef as ReactComponent };